import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { JobWorkService, WorkOrderService } from "../../../services/index";
import { SaleDC } from "../../../services/salesDc.service";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditJobWoDelivery.html",
})
export class addEditJobWoDelivery {
  row: any;
  data: any;
  designdata: any = {};
  acdata: any = {
    party_code: "UNIT 1",
    party_name: "SKT CLOTHING CO",
    totalmtr: 0,
    totalamt: 0,
  };
  qualityList: any;
  typeList: any;
  box: boolean;
  shirt: boolean;
  colorList: any;
  codeList: any;
  widthList: any[];
  box_print: string;
  onsaveDisable: boolean = false;
  noofpcs: number;
  res1: any;
  export: boolean = false;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  printPreview = [];
  shadeList: any = [];

  // rgrnList = [{
  //     shade: '',
  //     meter: 0,
  //     f36: 0,
  //     f38: 0,
  //     f40: 0,
  //     f42: 0,
  //     f44: 0,
  //     h36: 0,
  //     h38: 0,
  //     h40: 0,
  //     h42: 0,
  //     h44: 0,
  //     totmtrs: 0
  // }];
  rgrnList = [
    {
      shirt_design_no: "",
      shade: "",
      rf34: 0,
      rf36: 0,
      rf38: 0,
      rf40: 0,
      rf42: 0,
      rf44: 0,
      rf46: 0,
      rh34: 0,
      rh36: 0,
      rh38: 0,
      rh40: 0,
      rh42: 0,
      rh44: 0,
      rh46: 0,
      rfdif: 0,
      rhdif: 0,
      rtotmtrs: 0,
      rbalmtrs: 0,
    },
  ];
  designList = [
    {
      design_no: "",
      dshade: "",
      dcolor: "",
      df34: 0,
      df36: 0,
      df38: 0,
      df40: 0,
      df42: 0,
      df44: 0,
      df46: 0,
      dh34: 0,
      dh36: 0,
      dh38: 0,
      dh40: 0,
      dh42: 0,
      dh44: 0,
      dh46: 0,
      dftot: 0,
      dhtot: 0,
      dfs_total: 0,
      dhs_total: 0,
    },
  ];
  mode: string;
  saveEvent: any;
  agentList: any;
  cancelList = [
    {
      shade: "",
      color: "",
      slv: "",
      size: "",
      qty: "",
    },
  ];
  balanceList = [
    {
      shade: "",
      color: "",
      bal_bit_mtrs: 0,
      balmtrs: 0,
      ac_det_id: "",
      shirt_design_no: "",
      fab_design: "",
      width: "",
    },
  ];
  actual_balanceList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  checked: boolean = true;
  isLoadMask: Promise<any>;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.acdata = designdata;
    if (this.mode == "Edit" || this.mode == "View") {
      this.acdata.ac_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.getpartyname(this.acdata.party_code);
      this.getWoDelList(this.acdata.rgrn_id);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private saleDC: SaleDC,
    private woservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private rgrnService: JobWorkService
  ) {}
  ngOnInit() {
    this.calcdGrandTotal();

    if (this.mode == "Add") {
      this.acdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.acdata.party_code = "UNIT 1";
      this.getpartyname(this.acdata.party_code);
      this.getWoDelAuto();
    }
    this.tableScroll();
  }

  tableScroll() {
    $(".acbody").height(window.innerHeight - 600);
    $(".acbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    if (this.mode == "Add") {
      setTimeout(() => {
        $("#wono").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#f36-1").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  onGoToNextFld1($event, fld, ind) {
    let nxtInd = ind,
      shade = this.rgrnList[ind]["shade"],
      // meter = this.rgrnList[ind]['meter'],
      // fper = this.rgrnList[ind]['fper'],
      // hper = this.rgrnList[ind]['hper'];
      f36 = this.rgrnList[ind].rf36,
      f38 = this.rgrnList[ind].rf38,
      f40 = this.rgrnList[ind].rf40,
      f42 = this.rgrnList[ind].rf42,
      f44 = this.rgrnList[ind].rf44,
      h36 = this.rgrnList[ind].rh36,
      h38 = this.rgrnList[ind].rh38,
      h40 = this.rgrnList[ind].rh40,
      h42 = this.rgrnList[ind].rh42,
      h44 = this.rgrnList[ind].rh44;
    //   balmtrs = this.rgrnList[ind].fbalmtrs,
    //   totmtrs = this.rgrnList[ind]['totmtrs'];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "f36") {
      this.onSelectShade(this.rgrnList[ind]["shade"], ind);
      $("#" + "f36" + "-" + nxtInd).focus();
      return false;
    }
    if (fld == "dshade" && nxtRow.length == 0) {
      let len = this.rgrnList.length;
      let shade = this.rgrnList[len - 1]["shade"];

      nxtInd = nxtInd + 1;
      $("#" + "shade" + "-" + nxtInd).focus();

      if (shade != "" && nxtInd == len) {
        this.rgrnList.push({
          shirt_design_no: "",
          shade: "",
          rf34: 0,
          rf36: 0,
          rf38: 0,
          rf40: 0,
          rf42: 0,
          rf44: 0,
          rf46: 0,
          rh34: 0,
          rh36: 0,
          rh38: 0,
          rh40: 0,
          rh42: 0,
          rh44: 0,
          rh46: 0,
          rfdif: 0,
          rhdif: 0,
          rtotmtrs: 0,
          rbalmtrs: 0,
        });

        $("#" + "dshade" + "-" + nxtInd).focus();
      } else if (shade == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "shade" + "-" + a).focus();
      } else {
        $("#" + "shade" + "-" + nxtInd).focus();

        return false;
      }
    } else {
      /*  else if (fld=="f38" || fld=="f40" || fld=="f42" || fld=="f44" ||
            fld=="h36" || fld=="h38" || fld=="h40" || fld=="h42" || fld=="h44") {
            $('#'  + fld + '-' + nxtInd).select();
           
        }else if(fld=="f36"){
            nxtInd = nxtInd +1;
             $('#'  + fld + '-' + nxtInd).select();
        }
        else if (fld == "item_name") {
            let nxtRowID = nxtRow[0].id;
            nxtInd = nxtRowID.split("-")[1];
        } */
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  addCancelDetails(ind) {
    let len = this.cancelList.length;
    this.cancelList[len] = this.cancelList[ind];
    this.cancelList[0] = {
      shade: "",
      color: "",
      slv: "",
      size: "",
      qty: "",
    };
    $("#" + "shade3" + "-" + 0).focus();
  }
  addBitDetails(ind) {
    let len = this.balanceList.length;
    this.balanceList[len] = this.balanceList[ind];
    this.balanceList[0] = {
      shade: "",
      color: "",
      bal_bit_mtrs: 0,
      balmtrs: 0,
      ac_det_id: "",
      shirt_design_no: "",
      fab_design: "",
      width: "",
    };
    $("#" + "bitShade" + "-" + 0).focus();
  }
  getcolor1(shirtdno, shade, ind) {
    let params = {
      shirtdno: shirtdno,
      shade: shade,
    };
    this.rgrnService.getcolor(params).then((res: any) => {
      this.cancelList[ind].color = res.data[0].color;
    });
  }
  getcolorBit(shade, ind) {
    let colorExists = this.actual_balanceList.findIndex(
      (el) => el.shade == shade
    );
    this.balanceList[ind].color = this.actual_balanceList[colorExists].color;
    this.balanceList[ind].ac_det_id = this.actual_balanceList[
      colorExists
    ].ac_det_id;
    this.balanceList[ind].fab_design = this.actual_balanceList[
      colorExists
    ].fab_design;
    this.balanceList[ind].shirt_design_no = this.actual_balanceList[
      colorExists
    ].shirt_design_no;
    this.balanceList[ind].width = this.actual_balanceList[colorExists].width;
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;

    // shade = this.rgrnList[ind]['shade'],
    // meter = this.rgrnList[ind]['meter'],
    // fper = this.rgrnList[ind]['fper'],
    // hper = this.rgrnList[ind]['hper'];
    /*  f36 = this.designList[ind].f36,
         f38 = this.designList[ind].f38,
         f40 = this.designList[ind].f40,
         f42 = this.designList[ind].f42,
         f44 = this.designList[ind].f44,
         h36 = this.designList[ind].h36,
         h38 = this.designList[ind].h38,
         h40 = this.designList[ind].h40,
         h42 = this.designList[ind].h42,
         h44 = this.designList[ind].h44, */
    //   balmtrs = this.designList[ind].fbalmtrs,
    //   totmtrs = this.designList[ind]['totmtrs'];

    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "f36") {
      this.onSelectShade(this.designList[ind]["shade"], ind);
      $("#" + "f36" + "-" + nxtInd).focus();
      return false;
    }
    if (fld == "dshade" && nxtRow.length == 0) {
      let len = this.designList.length;
      let shade = this.designList[len - 1]["dshade"];

      nxtInd = nxtInd + 1;
      $("#" + "dshade" + "-" + nxtInd).focus();

      if (shade != "" && nxtInd == len) {
        this.designList.push({
          design_no: "",
          dshade: "",
          dcolor: "",
          df34: 0,
          df36: 0,
          df38: 0,
          df40: 0,
          df42: 0,
          df44: 0,
          df46: 0,
          dh34: 0,
          dh36: 0,
          dh38: 0,
          dh40: 0,
          dh42: 0,
          dh44: 0,
          dh46: 0,
          dftot: 0,
          dhtot: 0,
          dfs_total: 0,
          dhs_total: 0,
        });

        $("#" + "dshade" + "-" + nxtInd).focus();
      } else if (shade == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + "shade" + "-" + a).focus();
      } else {
        $("#" + "shade" + "-" + nxtInd).focus();

        return false;
      }
    } else {
      /*  else if (fld=="f38" || fld=="f40" || fld=="f42" || fld=="f44" ||
            fld=="h36" || fld=="h38" || fld=="h40" || fld=="h42" || fld=="h44") {
            $('#'  + fld + '-' + nxtInd).select();
           
        }else if(fld=="f36"){
            nxtInd = nxtInd +1;
             $('#'  + fld + '-' + nxtInd).select();
        }
        else if (fld == "item_name") {
            let nxtRowID = nxtRow[0].id;
            nxtInd = nxtRowID.split("-")[1];
        } */
      setTimeout(() => {
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  // onGoToNextFld($event, fld, ind) {
  //     let nxtInd = ind,

  //         f36 = this.designList[ind].df36,
  //         f38 = this.designList[ind].df38,
  //         f40 = this.designList[ind].df40,
  //         f42 = this.designList[ind].df42,
  //         f44 = this.designList[ind].df44,
  //         h36 = this.designList[ind].dh36,
  //         h38 = this.designList[ind].dh38,
  //         h40 = this.designList[ind].dh40,
  //         h42 = this.designList[ind].dh42,
  //         h44 = this.designList[ind].dh44,

  //         totmtrs = this.designList[ind]['totmtrs'];

  //     let nxtRow = $('#row-' + ind).next('tr');
  //     if (fld == "shade" && nxtRow.length == 0) {
  //         let len = this.designList.length;
  //         let shade = this.designList[len - 1]['shade'];

  //         nxtInd = nxtInd + 1;
  //         $('#' + 'shade' + '-' + nxtInd).focus();

  //         if (shade != '' && nxtInd == len) {

  //             this.designList.push({
  //                 design_no: '',
  //                 dshade: '',
  //                 dcolor:'',
  //                 df36: 0,
  //                 df38: 0,
  //                 df40: 0,
  //                 df42: 0,
  //                 df44: 0,
  //                 df46:0,
  //                 dh36: 0,
  //                 dh38: 0,
  //                 dh40: 0,
  //                 dh42: 0,
  //                 dh44: 0,
  //                 dh46: 0,
  //                 dftot:0,
  //                 dhtot:0,
  //                 dfs_total: 0,
  //                 dhs_total: 0

  //             });

  //             $( 'dshade' + '-' + nxtInd).focus();

  //         } else if (shade == '' && nxtInd == len) {
  //             let a = nxtInd - 1;
  //             $('#' + 'dshade' + '-' + a).focus();
  //         }
  //         else {

  //             $('#' + 'dshade' + '-' + nxtInd).focus();

  //             return false;

  //         }

  //     }
  //     else if (fld == "df36" || fld == "df38" || fld == "df40" || fld == "df42" || fld == "df44") {
  //         $('#' + fld + '-' + nxtInd).select();
  //     } else if (fld == "dh36" || fld == "dh38" || fld == "dh40" || fld == "dh42" || fld == "dh44") {
  //         $('#' + fld + '-' + nxtInd).select();
  //     }
  //     else if (fld == "item_name") {
  //         let nxtRowID = nxtRow[0].id;
  //         nxtInd = nxtRowID.split("-")[1];
  //     } else {

  //         setTimeout(() => {
  //             $('#' + fld + '-' + nxtInd).focus();
  //         }, 100);

  //     }
  // }

  onSelectShade(shade, ind) {
    let params = {
      fab_design_no: this.acdata.fab_design_no,
      color: shade,
    };
    let that = this;
    that.woservice.getStock(params).then((res: any) => {
      if (res.data.length > 0) {
        //         this.stockdata = res.data;
      } else {
        this.designList[ind]["mtr"] = "";
        this.designList[ind]["fs_tot_cons"] = 0;
        this.designList[ind]["hs_tot_cons"] = 0;
        this.designList[ind]["fs_tot_pcs"] = 0;
        this.designList[ind]["hs_tot_pcs"] = 0;
        this.designList[ind]["f34"] = 0;
        this.designList[ind]["f36"] = 0;
        this.designList[ind]["f38"] = 0;
        this.designList[ind]["f40"] = 0;
        this.designList[ind]["f42"] = 0;
        this.designList[ind]["f44"] = 0;
        this.designList[ind]["f46"] = 0;
        this.designList[ind]["h34"] = 0;
        this.designList[ind]["h36"] = 0;
        this.designList[ind]["h38"] = 0;
        this.designList[ind]["h40"] = 0;
        this.designList[ind]["h42"] = 0;
        this.designList[ind]["h44"] = 0;
        this.designList[ind]["h46"] = 0;
        //         this.calcBalMtrs(ind);
      }
      // this.designList[ind]['mtr']=this.stockdata[0]['avl_mtrs'];
      // this.woCalc(ind);
    });
  }

  // calcTotal($event,ind){
  //     let item = this.designList[ind];

  //     let totalmtrs = item.rf36+ item.rf38 + item.rf40 + item.rf42 +item.rf44
  //      + item.rh36 + item.rh38 + item.rh40 + item.rh42 + item.rh44;
  //     this.designList[ind]['rftot'] =  item.rf36+ item.rf38 + item.rf40 + item.rf42 +item.rf44;
  //     this.designList[ind]['rhtot'] = item.rh36 + item.rh38 + item.rh40 + item.rh42 + item.rh44;
  //     this.designList[ind].rtotmtrs = parseFloat(totalmtrs.toFixed(3));

  //         this.calcRate();

  // }

  calcTotal(ind) {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    for (let i = 0; i < this.rgrnList.length; i++) {
      //ftotalpcs
      this.rgrnList[ind]["rftot"] =
      nan(this.rgrnList[ind]["rf34"]) +
        nan(this.rgrnList[ind]["rf36"]) +
        nan(this.rgrnList[ind]["rf38"]) +
        nan(this.rgrnList[ind]["rf40"]) +
        nan(this.rgrnList[ind]["rf42"]) +
        nan(this.rgrnList[ind]["rf44"]) +
        nan(this.rgrnList[ind]["rf46"]);

      //htotalpcs
      this.rgrnList[ind]["rhtot"] =
      nan(this.rgrnList[ind]["rh34"]) +
        nan(this.rgrnList[ind]["rh36"]) +
        nan(this.rgrnList[ind]["rh38"]) +
        nan(this.rgrnList[ind]["rh40"]) +
        nan(this.rgrnList[ind]["rh42"]) +
        nan(this.rgrnList[ind]["rh44"]) +
        nan(this.rgrnList[ind]["rh46"]);

      //calccons
      this.rgrnList[ind]["ravg_cons"] = (
        nan(this.rgrnList[ind]["mtr"]) /
        (nan(this.rgrnList[ind]["rftot"]) + nan(this.rgrnList[ind]["rhtot"]))
      ).toFixed(2);
      //  this.rgrnList[ind]['rhavg_cons']= (nan(this.rgrnList[ind]['mtr'])/(nan(this.rgrnList[ind]['rftot'])+nan(this.rgrnList[ind]['rhtot']))).toFixed(2);

      //calcdiff
      this.rgrnList[ind]["rfdif"] =
        nan(this.rgrnList[ind]["ftot"]) - nan(this.rgrnList[ind]["rftot"]);
      this.rgrnList[ind]["rhdif"] =
        nan(this.rgrnList[ind]["htot"]) - nan(this.rgrnList[ind]["rhtot"]);
    }
    // for (let i = 0; i < this.designList.length; i++) {
    //     //ftotalpcs
    //     this.designList[ind]['dftot'] = nan(this.designList[ind]['df36']) + nan(this.designList[ind]['df38']) + nan(this.designList[ind]['df40']) + nan(this.designList[ind]['df42']) + nan(this.designList[ind]['df44']) + nan(this.designList[ind]['df46']);

    //     //htotalpcs
    //     this.designList[ind]['dhtot'] = nan(this.designList[ind]['dh36']) + nan(this.designList[ind]['dh38']) + nan(this.designList[ind]['dh40']) + nan(this.designList[ind]['dh42']) + nan(this.designList[ind]['dh44']) + nan(this.designList[ind]['dh46']);

    //     //calccons
    //     // this.designList[ind]['ravg_cons'] = (nan(this.designList[ind]['mtr']) / (nan(this.designList[ind]['rftot']) + nan(this.designList[ind]['rhtot']))).toFixed(2);
    //     //  this.designList[ind]['rhavg_cons']= (nan(this.designList[ind]['mtr'])/(nan(this.designList[ind]['rftot'])+nan(this.designList[ind]['rhtot']))).toFixed(2);

    //     //calcdiff
    //     this.designList[ind]['rfdif'] = nan(this.designList[ind]['ftot']) - nan(this.designList[ind]['rftot']);
    //     this.designList[ind]['rhdif'] = nan(this.rgrnList[ind]['htot']) - nan(this.rgrnList[ind]['rhtot']);

    // }
    this.calcGrandTotal();
  }
  calcTotal1(ind) {
    let nan = function (no) {
      if (no == "" || no == null) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };
    for (let i = 0; i < this.designList.length; i++) {
      //ftotalpcs

      this.designList[ind]["dftot"] =
      nan(this.designList[ind]["df34"]) +
        nan(this.designList[ind]["df36"]) +
        nan(this.designList[ind]["df38"]) +
        nan(this.designList[ind]["df40"]) +
        nan(this.designList[ind]["df42"]) +
        nan(this.designList[ind]["df44"]) +
        nan(this.designList[ind]["df46"]);

      //htotalpcs
      this.designList[ind]["dhtot"] =
      nan(this.designList[ind]["dh34"]) +
        nan(this.designList[ind]["dh36"]) +
        nan(this.designList[ind]["dh38"]) +
        nan(this.designList[ind]["dh40"]) +
        nan(this.designList[ind]["dh42"]) +
        nan(this.designList[ind]["dh44"]) +
        nan(this.designList[ind]["dh46"]);

      //calccons
      // this.designList[ind]['ravg_cons'] = (nan(this.designList[ind]['mtr']) / (nan(this.designList[ind]['rftot']) + nan(this.designList[ind]['rhtot']))).toFixed(2);
      //  this.designList[ind]['rhavg_cons']= (nan(this.designList[ind]['mtr'])/(nan(this.designList[ind]['rftot'])+nan(this.designList[ind]['rhtot']))).toFixed(2);

      //calcdiff
      //    this.designList[ind]['rfdif'] = nan(this.designList[ind]['ftot']) - nan(this.designList[ind]['rftot']);
      //            this.designList[ind]['rhdif'] = nan(this.rgrnList[ind]['htot']) - nan(this.rgrnList[ind]['rhtot']);
    }
    this.calcdGrandTotal();
  }
  woCalc(ind) {}
  calcGrandTotal() {
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      f34_tot = 0,
      f36_tot = 0,
      f38_tot = 0,
      f40_tot = 0,
      f42_tot = 0,
      f44_tot = 0,
      f46_tot = 0,
      h34_tot = 0,
      h36_tot = 0,
      h38_tot = 0,
      h40_tot = 0,
      h42_tot = 0,
      h44_tot = 0,
      bal_tot = 0,
      h46_tot = 0,
      fdif_tot = 0,
      hdif_tot = 0;
    for (let i = 0; i < this.rgrnList.length; i++) {
      let des = this.rgrnList[i];
      f34_tot += nan(des["rf34"]);
      f36_tot += nan(des["rf36"]);
      f38_tot += nan(des["rf38"]);
      f40_tot += nan(des["rf40"]);
      f42_tot += nan(des["rf42"]);
      f44_tot += nan(des["rf44"]);
      f46_tot += nan(des["rf46"]);
      bal_tot += nan(des["rbalmtrs"]);
      h34_tot += nan(des["rh34"]);
      h36_tot += nan(des["rh36"]);
      h38_tot += nan(des["rh38"]);
      h40_tot += nan(des["rh40"]);
      h42_tot += nan(des["rh42"]);
      h44_tot += nan(des["rh44"]);
      h46_tot += nan(des["rh46"]);
      fdif_tot += nan(des["rfdif"]);
      hdif_tot += nan(des["rhdif"]);
    }
    this.acdata["rf34_tot"] = f34_tot;
    this.acdata["rf36_tot"] = f36_tot;
    this.acdata["rf38_tot"] = f38_tot;
    this.acdata["rf40_tot"] = f40_tot;
    this.acdata["rf42_tot"] = f42_tot;
    this.acdata["rf44_tot"] = f44_tot;
    this.acdata["rf46_tot"] = f46_tot;
    this.acdata["rh34_tot"] = h34_tot;
    this.acdata["rh36_tot"] = h36_tot;
    this.acdata["rh38_tot"] = h38_tot;
    this.acdata["rh40_tot"] = h40_tot;
    this.acdata["rh42_tot"] = h42_tot;
    this.acdata["rh44_tot"] = h44_tot;
    this.acdata["rh46_tot"] = h46_tot;
    this.acdata["bal_tot"] = bal_tot;
    this.acdata["fdif_tot"] = fdif_tot;
    this.acdata["hdif_tot"] = hdif_tot;
    this.acdata["rfs_total"] =
    nan(f34_tot) +
      nan(f36_tot) +
      nan(f38_tot) +
      nan(f40_tot) +
      nan(f42_tot) +
      nan(f44_tot) +
      nan(f46_tot);
    this.acdata["rhs_total"] =
    nan(h34_tot) +
      nan(h36_tot) +
      nan(h38_tot) +
      nan(h40_tot) +
      nan(h42_tot) +
      nan(h44_tot) +
      nan(h46_tot);

      this.acdata["rfh34_tot"] =
      nan(this.acdata["rf34_tot"]) + nan(this.acdata["rh34_tot"]);
    this.acdata["rfh36_tot"] =
      nan(this.acdata["rf36_tot"]) + nan(this.acdata["rh36_tot"]);
    this.acdata["rfh38_tot"] =
      nan(this.acdata["rf38_tot"]) + nan(this.acdata["rh38_tot"]);
    this.acdata["rfh40_tot"] =
      nan(this.acdata["rf40_tot"]) + nan(this.acdata["rh40_tot"]);
    this.acdata["rfh42_tot"] =
      nan(this.acdata["rf42_tot"]) + nan(this.acdata["rh42_tot"]);
    this.acdata["rfh44_tot"] =
      nan(this.acdata["rf44_tot"]) + nan(this.acdata["rh44_tot"]);
    this.acdata["rfh46_tot"] =
      nan(this.acdata["rf46_tot"]) + nan(this.acdata["rh46_tot"]);
    this.acdata["rtot_pcs"] =
      nan(this.acdata["rfs_total"]) + nan(this.acdata["rhs_total"]);
    this.acdata["tot_dif"] =
      nan(this.acdata["fdif_tot"]) + nan(this.acdata["hdif_tot"]);

    this.calcDiff();
  }
  getcolor(shirtdno, shade, ind) {
    let params = {
      shirtdno: shirtdno,
      shade: shade,
    };
    this.rgrnService.getcolor(params).then((res: any) => {
      this.designList[ind].dcolor = res.data[0].color;
    });
  }
  calcdGrandTotal() {
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      df34_tot = 0,
      df36_tot = 0,
      df38_tot = 0,
      df40_tot = 0,
      df42_tot = 0,
      df44_tot = 0,
      df46_tot = 0,
      dh34_tot = 0,
      dh36_tot = 0,
      dh38_tot = 0,
      dh40_tot = 0,
      dh42_tot = 0,
      dh44_tot = 0,
      dh46_tot = 0;
    for (let i = 0; i < this.designList.length; i++) {
      let des = this.designList[i];
      df34_tot += nan(des["df34"]);
      df36_tot += nan(des["df36"]);
      df38_tot += nan(des["df38"]);
      df40_tot += nan(des["df40"]);
      df42_tot += nan(des["df42"]);
      df44_tot += nan(des["df44"]);
      df46_tot += nan(des["df46"]);
      dh34_tot += nan(des["dh34"]);
      dh36_tot += nan(des["dh36"]);
      dh38_tot += nan(des["dh38"]);
      dh40_tot += nan(des["dh40"]);
      dh42_tot += nan(des["dh42"]);
      dh44_tot += nan(des["dh44"]);
      dh46_tot += nan(des["dh46"]);
    }
    this.acdata["df34_tot"] = df34_tot;
    this.acdata["df36_tot"] = df36_tot;
    this.acdata["df38_tot"] = df38_tot;
    this.acdata["df40_tot"] = df40_tot;
    this.acdata["df42_tot"] = df42_tot;
    this.acdata["df44_tot"] = df44_tot;
    this.acdata["df46_tot"] = df46_tot;
    this.acdata["dh34_tot"] = dh34_tot;
    this.acdata["dh36_tot"] = dh36_tot;
    this.acdata["dh38_tot"] = dh38_tot;
    this.acdata["dh40_tot"] = dh40_tot;
    this.acdata["dh42_tot"] = dh42_tot;
    this.acdata["dh44_tot"] = dh44_tot;
    this.acdata["dh46_tot"] = dh46_tot;
    this.acdata["dfs_total"] =
    nan(df34_tot) +
      nan(df36_tot) +
      nan(df38_tot) +
      nan(df40_tot) +
      nan(df42_tot) +
      nan(df44_tot) +
      nan(df46_tot);
    this.acdata["dhs_total"] =
    nan(dh34_tot) +
      nan(dh36_tot) +
      nan(dh38_tot) +
      nan(dh40_tot) +
      nan(dh42_tot) +
      nan(dh44_tot) +
      nan(dh46_tot);
      this.acdata["dfh34_tot"] =
      nan(this.acdata["df34_tot"]) + nan(this.acdata["dh34_tot"]);
    this.acdata["dfh36_tot"] =
      nan(this.acdata["df36_tot"]) + nan(this.acdata["dh36_tot"]);
    this.acdata["dfh38_tot"] =
      nan(this.acdata["df38_tot"]) + nan(this.acdata["dh38_tot"]);
    this.acdata["dfh40_tot"] =
      nan(this.acdata["df40_tot"]) + nan(this.acdata["dh40_tot"]);
    this.acdata["dfh42_tot"] =
      nan(this.acdata["df42_tot"]) + nan(this.acdata["dh42_tot"]);
    this.acdata["dfh44_tot"] =
      nan(this.acdata["df44_tot"]) + nan(this.acdata["dh44_tot"]);
    this.acdata["dfh46_tot"] =
      nan(this.acdata["df46_tot"]) + nan(this.acdata["dh46_tot"]);
    this.acdata["dtot_pcs"] =
      nan(this.acdata["dfs_total"]) + nan(this.acdata["dhs_total"]);

    this.calcDiff();
  }
  calcDiff() {
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      rtot_dif = 0;
    for (let i = 0; i < this.rgrnList.length; i++) {
      let des = this.rgrnList[i];
      rtot_dif += nan(des["frdif"]) + nan(des["rhdif"]);
    }
    this.acdata["rtot_dif"] = rtot_dif;
  }

  calcRate() {
    let item = this.rgrnList;

    let fullrate = 0,
      halfrate = 0,
      totalrate = 0;
    for (let i = 0; i < item.length; i++) {
      fullrate +=
      item[i].rf34 +
        item[i].rf36 +
        item[i].rf38 +
        item[i].rf40 +
        item[i].rf42 +
        item[i].rf44;
      halfrate +=
      item[i].rh34 +
        item[i].rh36 +
        item[i].rh38 +
        item[i].rh40 +
        item[i].rh42 +
        item[i].rh44;
      totalrate = fullrate + halfrate;
    }

    this.acdata.fullrate = fullrate;
    this.acdata.halfrate = halfrate;
    this.acdata.totalrate = totalrate;
  }
  // getworkOrder(wo_no){
  //     let params ={
  //         wo_no : wo_no
  //     }
  //     this.rgrnService
  //     .getworkOrder(params)
  //     .then((res: any) => {

  //     });
  // }
  getworkOrder(wono) {
    if (wono == null) {
      this.acdata.wo_id = "";
      this.acdata.shirt_design = "";
      this.acdata.brand = "";
      this.acdata.style = "";
      this.acdata.fab_design = "";
      this.acdata.rate = "";
      this.acdata.wo_date = "";
      this.acdata.width = "";
      this.acdata.age = "";
      this.acdata.rf34_tot = "";
      this.acdata.rf36_tot = "";
      this.acdata.rf38_tot = "";
      this.acdata.rf40_tot = "";
      this.acdata.rf42_tot = "";
      this.acdata.rf44_tot = "";
      this.acdata.rf46_tot = "";
      this.acdata.rh34_tot = "";
      this.acdata.rh36_tot = "";
      this.acdata.rh38_tot = "";
      this.acdata.rh40_tot = "";
      this.acdata.rh42_tot = "";
      this.acdata.rh44_tot = "";
      this.acdata.rh46_tot = "";
      this.acdata.rfh34_tot = "";
      this.acdata.rfh36_tot = "";
      this.acdata.rfh38_tot = "";
      this.acdata.rfh40_tot = "";
      this.acdata.rfh42_tot = "";
      this.acdata.rfh44_tot = "";
      this.acdata.rfh46_tot = "";
      this.acdata.rfh46_tot = "";
      this.acdata.rfs_total = "";
      this.acdata.rhs_total = "";
      this.acdata.rtot_pcs = "";
      this.acdata.rtot_diff = "";
      this.acdata.f34_tot = "";
      this.acdata.f36_tot = "";
      this.acdata.f38_tot = "";
      this.acdata.f40_tot = "";
      this.acdata.f42_tot = "";
      this.acdata.f44_tot = "";
      this.acdata.f46_tot = "";
      this.acdata.h34_tot = "";
      this.acdata.h36_tot = "";
      this.acdata.h38_tot = "";
      this.acdata.h40_tot = "";
      this.acdata.h42_tot = "";
      this.acdata.h44_tot = "";
      this.acdata.h46_tot = "";
      this.acdata.fh34_tot = "";
      this.acdata.fh36_tot = "";
      this.acdata.fh38_tot = "";
      this.acdata.fh40_tot = "";
      this.acdata.fh42_tot = "";
      this.acdata.fh44_tot = "";
      this.acdata.fh46_tot = "";
      this.acdata.fh46_tot = "";
      this.acdata.fs_total = "";
      this.acdata.hs_total = "";
      this.acdata.tot_pcs = "";
      this.rgrnList = [
        {
          shirt_design_no: "",
          shade: "",
          rf34: 0,
          rf36: 0,
          rf38: 0,
          rf40: 0,
          rf42: 0,
          rf44: 0,
          rf46: 0,
          rh34: 0,
          rh36: 0,
          rh38: 0,
          rh40: 0,
          rh42: 0,
          rh44: 0,
          rh46: 0,
          rtotmtrs: 0,
          rfdif: 0,
          rhdif: 0,
          rbalmtrs: 0,
        },
      ];
    } else {
      let params = {
        wo_no: wono,
      };

      let that = this;
      that.rgrnService.getworkOrderWoDel(params).then((res: any) => {
        if (res.success == "false") {
          this.acdata.wo_no = null;
          $("#wo_no").focus();
          swal("ACTUAL CUTTING NOT COMPLETED");
          return false;
        } else if (res.success == "unapproved") {
          this.acdata.wo_no = null;
          $("#wo_no").focus();
          swal("KAJA & BUTTON NOT APPROVED");
          return false;
        } else {
          if (res.data == false) {
            this.acdata.wo_id = "";
            this.acdata.ac_id = "";
            this.acdata.cu_no = "";
            this.acdata.fit = "";
            this.acdata.shirt_design_no = "";
            this.acdata.brand = "";
            this.acdata.style = "";
            this.acdata.fab_no = "";
            this.acdata.wo_date = "";
            this.acdata.mrp = "";
            this.acdata.type = "";
            this.acdata.rate = "";
            this.acdata.wo_date = "";
            this.acdata.brand = "";
            this.acdata.age = "";
            this.acdata.rf34_tot = "";
            this.acdata.rf36_tot = "";
            this.acdata.rf38_tot = "";
            this.acdata.rf40_tot = "";
            this.acdata.rf42_tot = "";
            this.acdata.rf44_tot = "";
            this.acdata.rf46_tot = "";
            this.acdata.rh34_tot = "";
            this.acdata.rh36_tot = "";
            this.acdata.rh38_tot = "";
            this.acdata.rh40_tot = "";
            this.acdata.rh42_tot = "";
            this.acdata.rh44_tot = "";
            this.acdata.rh46_tot = "";
            this.acdata.rfh34_tot = "";
            this.acdata.rfh36_tot = "";
            this.acdata.rfh38_tot = "";
            this.acdata.rfh40_tot = "";
            this.acdata.rfh42_tot = "";
            this.acdata.rfh44_tot = "";
            this.acdata.rfh46_tot = "";
            this.acdata.rfh46_tot = "";
            this.acdata.rfs_total = "";
            this.acdata.rhs_total = "";
            this.acdata.rtot_pcs = "";
            this.acdata.rtot_diff = "";           
            this.acdata.df34_tot = 0; 
            this.acdata.df36_tot = 0;
            this.acdata.df38_tot = 0;
            this.acdata.df40_tot = 0;
            this.acdata.df42_tot = 0;
            this.acdata.df44_tot = 0;
            this.acdata.df46_tot = 0;
            this.acdata.dh34_tot = 0;
            this.acdata.dh36_tot = 0;
            this.acdata.dh38_tot = 0;
            this.acdata.dh40_tot = 0;
            this.acdata.dh42_tot = 0;
            this.acdata.dh44_tot = 0;
            this.acdata.dh46_tot = 0;
            this.acdata.dfh34_tot = 0;
            this.acdata.dfh36_tot = 0;
            this.acdata.dfh38_tot = 0;
            this.acdata.dfh40_tot = 0;
            this.acdata.dfh42_tot = 0;
            this.acdata.dfh44_tot = 0;
            this.acdata.dfh46_tot = 0;
            this.acdata.dfh46_tot = 0;
            this.acdata.dfs_total = 0;
            this.acdata.dhs_total = 0;
            this.acdata.dtot_pcs = 0;
            this.acdata.dtot_diff = 0;
            this.acdata.f34_tot = "";
            this.acdata.f36_tot = "";
            this.acdata.f38_tot = "";
            this.acdata.f40_tot = "";
            this.acdata.f42_tot = "";
            this.acdata.f44_tot = "";
            this.acdata.f46_tot = "";
            this.acdata.h34_tot = "";
            this.acdata.h36_tot = "";
            this.acdata.h38_tot = "";
            this.acdata.h40_tot = "";
            this.acdata.h42_tot = "";
            this.acdata.h44_tot = "";
            this.acdata.h46_tot = "";
            this.acdata.fh34_tot = "";
            this.acdata.fh36_tot = "";
            this.acdata.fh38_tot = "";
            this.acdata.fh40_tot = "";
            this.acdata.fh42_tot = "";
            this.acdata.fh44_tot = "";
            this.acdata.fh46_tot = "";
            this.acdata.fh46_tot = "";
            this.acdata.fs_total = "";
            this.acdata.hs_total = "";
            this.acdata.tot_pcs = "";
            this.acdata.bal_tot = "";
            this.rgrnList = [
              {
                shirt_design_no: "",
                shade: "",
                rf34: 0,
                rf36: 0,
                rf38: 0,
                rf40: 0,
                rf42: 0,
                rf44: 0,
                rf46: 0,
                rh34: 0,
                rh36: 0,
                rh38: 0,
                rh40: 0,
                rh42: 0,
                rh44: 0,
                rh46: 0,
                rtotmtrs: 0,
                rfdif: 0,
                rhdif: 0,
                rbalmtrs: 0,
              },
            ];
            this.balanceList = [
              {
                shade: "",
                color: "",
                bal_bit_mtrs: 0,
                balmtrs: 0,
                ac_det_id: "",
                shirt_design_no: "",
                fab_design: "",
                width: "",
              },
            ];
          } else {
            that.acdata.wo_id = res.data[0].wo_id;
            that.acdata.ac_id = res.data[0].ac_id;
            that.acdata.shirt_design_no = res.data[0].shirt_design_no;
            that.acdata.cu_no = res.data[0].cu_no;
            that.acdata.style = res.data[0].style;
            that.acdata.mrp = res.data[0].mrp;
            that.acdata.fab_no = res.data[0].fab_design_no;
            // that.acdata.sample_no = res.data[0].sample_no;
            that.acdata.wo_date = res.data[0].wo_date;
            //   that.acdata.date = res.date;
            that.acdata.brand = res.data[0].brand;
            that.acdata.brand = res.data[0].brand;
            that.acdata.fit = res.data[0].fit;
            that.acdata.type = res.data[0].cost_sam_type;
            that.acdata.fh34_tot = res.data[0].fh34_tot;
            that.acdata.fh36_tot = res.data[0].fh36_tot;
            that.acdata.fh38_tot = res.data[0].fh38_tot;
            that.acdata.fh40_tot = res.data[0].fh40_tot;
            that.acdata.fh42_tot = res.data[0].fh42_tot;
            that.acdata.fh44_tot = res.data[0].fh44_tot;
            that.acdata.fh46_tot = res.data[0].fh46_tot;
            that.acdata.fs_total = res.data[0].fs_total;
            that.acdata.hs_total = res.data[0].hs_total;
            that.acdata.tot_pcs = res.data[0].tot_pcs;
            let wodate: any = new Date(res.data[0].wo_date);
            let date: any = new Date(that.acdata.date);
            //     that.acdata.age = res.data[0].wo_date-that.acdata.date;
            that.acdata.age = (date - wodate) / (1000 * 60 * 60 * 24);
            that.rgrnList;
            that.rgrnList = res.list;
            that.actual_balanceList = res.balanceData;

            that.shadeList = res.shade;
            let f34_tot = 0,
              f36_tot = 0,
              f38_tot = 0,
              f40_tot = 0,
              f42_tot = 0,
              f44_tot = 0,
              f46_tot = 0,
              h34_tot = 0,
              h36_tot = 0,
              h38_tot = 0,
              h40_tot = 0,
              h42_tot = 0,
              h44_tot = 0,
              h46_tot = 0;
            for (let i = 0; i < res.list.length; i++) {
              let des = res.list[i];
              f34_tot += des.f34;
              f36_tot += des.f36;
              f38_tot += des.f38;
              f40_tot += des.f40;
              f42_tot += des.f42;
              f44_tot += des.f44;
              f46_tot += des.f46;
              h34_tot += des.h34;
              h36_tot += des.h36;
              h38_tot += des.h38;
              h40_tot += des.h40;
              h42_tot += des.h42;
              h44_tot += des.h44;
              h46_tot += des.h46;
              this.rgrnList[i].rf34 = 0;
              this.rgrnList[i].rf36 = 0;
              this.rgrnList[i].rf38 = 0;
              this.rgrnList[i].rf40 = 0;
              this.rgrnList[i].rf42 = 0;
              this.rgrnList[i].rf44 = 0;
              this.rgrnList[i].rf46 = 0;
              this.rgrnList[i].rh34 = 0;
              this.rgrnList[i].rh36 = 0;
              this.rgrnList[i].rh38 = 0;
              this.rgrnList[i].rh40 = 0;
              this.rgrnList[i].rh42 = 0;
              this.rgrnList[i].rh44 = 0;
              this.rgrnList[i].rh46 = 0;
              this.rgrnList[i].rbalmtrs = 0;
              this.calcTotal(i);
            }
            this.acdata["f34_tot"] = f34_tot;
            this.acdata["f36_tot"] = f36_tot;
            this.acdata["f38_tot"] = f38_tot;
            this.acdata["f40_tot"] = f40_tot;
            this.acdata["f42_tot"] = f42_tot;
            this.acdata["f44_tot"] = f44_tot;
            this.acdata["f46_tot"] = f46_tot;
            this.acdata["h34_tot"] = h34_tot;
            this.acdata["h36_tot"] = h36_tot;
            this.acdata["h38_tot"] = h38_tot;
            this.acdata["h40_tot"] = h40_tot;
            this.acdata["h42_tot"] = h42_tot;
            this.acdata["h44_tot"] = h44_tot;
            this.acdata["h46_tot"] = h46_tot;
          }
        }
      });
    }
  }

  getpartyname(code) {
    let params = {
      code: code,
    };
    this.rgrnService.getPartyDet(params).then((res: any) => {
      this.acdata.party_name = res.data[0].party_name;
      this.acdata.party_id = res.data[0].party_id;
    });
  }
  // calcDiff(){
  //     let nan = function(no) {
  //         if(no=='' || no==null){
  //          return 0;
  //         }
  //      if(isNaN(no)) {
  //          return 0;
  //      }
  //      return parseFloat(no+'');
  //     },
  //     ac_tot_diff = 0;
  //     for(let i=0;i<this.rgrnList.length;i++){
  //         let rgrn = this.rgrnList[i];
  //         ac_tot_diff += nan(rgrn['r'])+nan(rgrn['ac_hs_diff']);
  //     }
  //     this.acdata['ac_tot_diff'] = ac_tot_diff;
  // }
  getWoDelList(rgrn_id) {
    let params = {
      rgrn_id: rgrn_id,
    };
    this.rgrnService.getWoDelList(params).then((res: any) => {
      this.acdata = res.acdata;
      this.shadeList = res.shade;

      this.cancelList = res.canceldata;
      this.balanceList = res.balancedata;
      if (res.canceldata.length == 0) {
        this.cancelList = [
          {
            shade: "",
            color: "",
            slv: "",
            size: "",
            qty: "",
          },
        ];
      }

      //    this.acdata.df36_tot = res.acdata.df36_tot;
      for (let i = 0; i < res.data.length; i++) {
        this.rgrnList[i] = res.data[i];
        // this.calcTotal('$event',i);
        //    this.calcGrandTotal();
        //     this.calcdGrandTotal();
      }
      for (let i = 0; i < res.detdata.length; i++) {
        this.rgrnList[i] = Object.assign({}, this.rgrnList[i], res.detdata[i]);
      }
      for (let i = 0; i < res.wodata.length; i++) {
        this.designList[i] = res.wodata[i];

        // this.calcTotal('$event',i);
        //    this.calcGrandTotal();
        //     this.calcdGrandTotal();
      }
    });
  }

  isRowEmpty(ind) {
    let data = this.data.rgrnList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.rgrnList.length > 1) {
          that.data.rgrnList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
        //    that.calcTotal($event,ind);
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }
  getWoDelAuto() {
    this.rgrnService.getWoDelAuto({}).then((res: any) => {
      this.acdata.ref_no = res;
    });
  }

  getDesignDetailsList(wono) {
    if (wono == null) {
      this.acdata.wo_id = "";
      this.acdata.shirtdno = "";
      this.acdata.brand = "";
      this.acdata.style = "";
    } else {
      let params = {
        wo_no: wono,
      };

      let that = this;
      that.rgrnService.getDesignDetailsList(params).then((res: any) => {
        that.acdata.wo_id = res.data[0].wo_id;
        that.acdata.shirtdno = res.data[0].shirtdno;
        that.acdata.brand = res.data[0].brand;
        that.acdata.style = res.data[0].style;
      });
    }
  }

  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.rgrnList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      this.onGoToNextFld($event, "quality", ind);
    } else {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ALREADY EXISTS",
        body: "Design with this shade Already Exists",
      });
      design.design_no = "";
      design.shade = "";
    }
  }

  oncheckemptyrow() {
    if (
      this.acdata.approval == null ||
      this.acdata.rgrn_no == 0 ||
      this.acdata.del_dc_no == 0 ||
      this.acdata.no_of_boxes == 0
    ) {
      swal("Make sure that all the details are given!! ");
    } else {
      let design = this.designList;
      let desList = [];
      for (let i = 0; i < design.length; i++) {
        if (design[i].dshade != "") {
          design[i].design_no = this.rgrnList[0].shirt_design_no;
          desList.push(design[i]);
        }
      }
      this.designList = desList;

      let design1 = this.rgrnList;
      let desList1 = [];
      for (let i = 0; i < design1.length; i++) {
        if (design1[i].shade != "") {
          desList1.push(design1[i]);
        }
      }
      this.rgrnList = desList1;

      let design2 = this.cancelList;
      let desList2 = [];
      for (let i = 0; i < design2.length; i++) {
        if (design2[i].shade != "") {
          desList2.push(design2[i]);
        }
      }

      let bal = this.balanceList;
      let balanceList1 = [];
      for (let i = 0; i < bal.length; i++) {
        if (bal[i].shade != "") {
          balanceList1.push(bal[i]);
        }
      }

      this.balanceList = balanceList1;

      //tally balance bit

      var exists = true;

      this.rgrnList.forEach((el) => {
        let exitsShade = this.balanceList.some(
          (elShade) => elShade.shade == el.shade
        );

        if (!exitsShade && Number(Number(el.rbalmtrs).toFixed(2)) > 0) {
          exists = false;
          return;
        }
        let total_bal = this.balanceList.reduce((a, item) => {
          if (item.shade == el.shade) {
            return (a += Number(Number(item.bal_bit_mtrs).toFixed(2)));
          }else{
            return a;
          }
        }, 0);

        if (Number(Number(total_bal).toFixed(2)) != Number(Number(el.rbalmtrs).toFixed(2))) {
          exists = false;
        }
      });

      if (!exists) {
        swal("Please tally balance bit meters with color wise meters");
        this.balanceList = [
          {
            shade: "",
            color: "",
            bal_bit_mtrs: 0,
            balmtrs: 0,
            ac_det_id: "",
            shirt_design_no: "",
            fab_design: "",
            width: "",
          },
        ];
        $("#bal_bit_mtrs-0").focus();
        return;
      }

      this.onSaveOrder();
    }
  }
  // checkBalanceBit(bal_bit_mtrs,ind){
  //   let bal_mtrs = Number(bal_bit_mtrs);
  //   if(this.balanceList[ind].balmtrs < bal_mtrs){
  //     this.balanceList[ind].bal_bit_mtrs = 0;
  //     this.toasterService.pop({
  //       bodyOutputType: 1,
  //       type: "error",
  //       title: "INVALID MTRS",
  //       body: "Bit entered was greater than balance bit availble in that lump",
  //     });
  //     $("#" + "bal_bit_mtrs" + "-" + ind).focus();
  //   }
  // }
  onSaveOrder(): void {
    if (this.acdata.wo_no == undefined || this.acdata.cu_no == undefined) {
      swal("Make sure that all the details are given!! ");
    } else {
      this.onsaveDisable = true;
      let params: any = Object.assign({}, this.acdata);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.designList);
      params["wodata"] = JSON.stringify(this.rgrnList);
      params["cancelData"] = JSON.stringify(this.cancelList);
      params["balanceData"] = JSON.stringify(this.balanceList);
      params["ac_date"] = this.datePipe.transform(
        params["ac_date"],
        "yyyy-MM-dd"
      );

      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this WO delivery details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      })
        .then(function () {
          that.isLoading = true;
          that.isLoadMask = that.rgrnService
            .saveOrderWoDel(params)
            .then(function (res: any) {
              that.onsaveDisable = true;
              that.isLoading = true;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }

              if (res.success) {
                that.res1 = res;
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };

                  that.tabUpdateEvent.emit(tabObj);
                }
                // that.printPreview = res.printData;
                // $("#printpr").modal("show");

                // that.print(res);
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
              } else {
                swal("ERROR", res.message, "error");
              }
            })
            .catch(function (error: any) {
              that.onsaveDisable = false;
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        })
        .catch(function (error: any) {
          that.onsaveDisable = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/addEditJobWoDelivery.ts